export const SIRIUS_PROMO_CODE = 'sirius_partnership'

export const CTA_ACTIONS: Record<string, string> = {
  primary: 'View Plans',
  dismiss: 'Dismiss',
}
